// extracted by mini-css-extract-plugin
export default {"container":"Console_container__w-+vt","message":"Console_message__I9Uk8"};